import "./Footer.css";

export default function Footer() {
  	return (
        <footer className="content-footer footer bg-footer-theme">
            <div className="container-xxl">
                <div className="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">
                    <div className="text-body">&#169; Skillati SW {new Date().getFullYear()} .  All rights reserved.</div>
                     <div className="d-none d-lg-inline-block">
                        <a target="_blank" className="footer-link me-4">Documentazione</a>
                        <a target="_blank" className="footer-link d-none d-sm-inline-block">Supporto</a>
                     </div>
                </div>
            </div>
        </footer>
	);
}